import React, { Component } from 'react';
import { Container, Row, Col, Input, Button, Alert } from 'reactstrap';
import { Link } from 'react-router-dom';
import AuthFunctions from '../services/AuthService';
import Session from '../auth/Session';

export class AcctDetails extends Component {
    static displayName = AcctDetails.name;

    constructor(props) {
        super(props);
        this.state = {
            isAdmin: false
        }

        this.checkAuthenticated();
    }

    async checkAuthenticated() {
        var isAuthenticated = await AuthFunctions.getAuthenticatedAsync();
        if (!isAuthenticated) {
            this.props.history.push('/login');
        }
    }

    async componentDidMount() {
        var _token = Session.getToken();
    }

    render() {
        return (
            <div className="pageDiv">
                <div id="head">
                    <h3 style={{ textAlign: 'center' }}>Change Password</h3>
                </div>
                <div id="body" className="g-light-gray-c">
                    <Row className="rowSpacing">
                        <Col style={{ textAlign: 'right' }} >
                            Previous Password
                        </Col>
                        <Col>
                            <div id="plain">&nbsp;
                                <input type="password"
                                    name="OldPassword"
                                    value={this.state.OldPassword}
                                    onChange={(e) => {
                                        this.setState({ OldPassword: e.target.value });
                                    }}
                                />
                            </div>
                        </Col>
                    </Row>
                    <Row className="rowSpacing">
                        <Col style={{ textAlign: 'right' }} >
                            New Password
                        </Col>
                        <Col>
                            <div id="plain">&nbsp;
                                <input type="password"
                                    name="NewPassword"
                                    value={this.state.NewPassword}
                                    onChange={(e) => {
                                        this.setState({ NewPassword: e.target.value });
                                    }}
                                />
                            </div>
                        </Col>
                    </Row>
                    <Row className="rowSpacing">
                        <Col style={{ textAlign: 'right' }} >
                            Re-type Password
                        </Col>
                        <Col>
                            <div id="plain">&nbsp;
                                <input type="password"
                                    name="RetypePassword"
                                    value={this.state.RetypePassword}
                                    onChange={(e) => {
                                        this.setState({ RetypePassword: e.target.value });
                                    }}
                                />
                            </div>
                        </Col>
                    </Row>
                    
                    <Row className="rowSpacing">
                        <Col style={{ textAlign: 'right' }} >
                            &nbsp;
                        </Col>
                        <Col>
                            <div id="controls" style={{ textAlign: 'left' }}>
                                <button className="gButton" style={{ backgroundColor: '#F26230', color: "#FFFFFF", boxShadow: "0 2px 5px 0 rgba(0, 0, 0, .26)", minWidth: "100px" }} onClick={() => {
                                    this.SavePassword();
                                }} >Submit</button>
                            </div>
                        </Col>
                    </Row>
                </div>

            </div>
        );
    }

    async SavePassword() {
        if (await this.IsValidPassword()) {
            var dto = { OldPW: this.state.OldPassword, NewPW: this.state.NewPassword, RetypePW: this.state.RetypePassword };
            const token = Session.getToken();
            const response = await fetch('api/Admin/SetPassword', {
                method: 'POST',
                headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
                body: JSON.stringify(dto)
            });
            if (response != null) {
                const data = await response.json();
                if (data.response !== "Success") {
                    alert(data.response);
                } else {
                    alert("Password changed!");
                    this.setState({ OldPassword: '', NewPassword: '', RetypePassword: '' });
                }
            }
            
            //const data = await response.json();
            //this.setState({ lease: data });
        }
    }

    async IsValidPassword() {
        if (!(this.state.OldPassword)) {
            alert("Old Password field must be filled out.");
            return false;
        }
        if (!(this.state.NewPassword)) {
            alert("New Password field must be filled out.");
            return false;
        }
        if (!(this.state.RetypePassword)) {
            alert("Re-type Password field must be filled out.");
            return false;
        }
        //Add complexity requirements here.
        if (!(this.state.NewPassword === this.state.RetypePassword)) {
            alert("Password fields must match.");
            return false;
        }
        return true;
    }
}
